import Color from 'color';
import store from '@/store';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';

export function updateTitle(to = {}) {
  const { title: application = 'DevicePilot' } = store.state.settings;
  const { meta: { title: page } = {} } = to;
  if (page) {
    document.title = `${page} - ${application}`;
  } else {
    document.title = application;
  }
}

export function updateFavicon() {
  const { favicon = '/favicon-32x32.png' } = store.state.settings;
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = favicon;
  document.getElementsByTagName('head')[0].appendChild(link);
}

export function updateColours() {
  const palette = store.getters[`${COLOURS}/${PALETTE_COLOURS}`];
  const { uiDark: dark = false } = store.state.persistence;

  // global styles
  if (dark) {
    document.body.classList.add('is-dark-mode');
  } else {
    document.body.classList.remove('is-dark-mode');
  }

  // css variable styles
  const keyed = Object.entries(palette)
    .reduce(
      (c, [k, v]) => ({
        ...c,
        ...(Array.isArray(v)
          ? v.reduce((o, a, i) => ({ ...o, [`${k}${i + 1}`]: a }), {})
          : { [k]: v }),
      }),
      {},
    );

  const luminosity = Color(palette.primaryPalette[3]).luminosity();
  if (luminosity > 0.25) {
    keyed.highlight = keyed.primary;
  } else {
    [,,, keyed.highlight] = palette.primaryPalette;
  }

  // Map mid status colours to default name
  keyed.success = keyed.successPalette3;
  keyed.warning = keyed.warningPalette3;
  keyed.error = keyed.errorPalette3;

  const white = Color('white');
  const black = Color(palette.dark);
  const { style } = document.documentElement;
  Object.entries(keyed).forEach(([k, v]) => {
    // colour css variable
    const colour = Color(v);
    const variable = `--colour-${k}`;
    style.removeProperty(variable);
    style.setProperty(variable, colour.string());
    // background contrast css variable
    const whiteContrast = colour.contrast(white);
    const colourContrast = whiteContrast > 1.8 ? white : black;
    const contrast = `${variable}-contrast`;
    style.removeProperty(contrast);
    style.setProperty(contrast, colourContrast.string());
  });
}
